import React, { useEffect } from "react";
import { Dimensions, Image, Text, TouchableOpacity, View,Linking } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize } from 'rn-responsive-styles';
import { FONTS, COLORS } from "../../constant";
const isSmallDevice = Dimensions.get('window').width < 767


const useStyles = CreateResponsiveStyle(
    {
        mobileFirstForwardViewStyle: {
            alignSelf: "flex-start",
            paddingLeft: "12%",
            marginBottom: 15,
            display: "none",
          },
          keepMvngTextStyle: {
            fontFamily: FONTS.Inter,
            fontSize: 23,
            fontWeight: 300,
            color: "#54565b",
            paddingTop: "10%",
          },
          forwardTextStyle: {
            fontFamily: "Inter",
            fontSize: 66,
            fontWeight: "normal",
            fontStyle: "normal",
            lineHeight: 66,
            letterSpacing: 0,
            textAlign: "left",
            color: "#9c1d25",
            paddingTop: 5,
          },
          oneFastagTextStyle: {
            fontFamily: "Inter",
            fontSize: 23,
            fontStyle: "normal",
            lineHeight: 32,
            letterSpacing: 1,
            textAlign: "left",
            color: "#54565b",
            paddingTop: "10%",
          },
          viewStyle1: {
            paddingTop: "10%",
            flexWrap: "wrap",
          },
          activateUserTextStyle: {
            fontFamily: "Inter",
            fontSize: 16,
            fontWeight: "normal",
            fontStyle: "normal",
            lineHeight: 12,
            letterSpacing: -0.2,
            textAlign: "left",
            color: "#54565b",
            textDecorationLine: "underline",
          },
          checkTagBalanceTextStyle: {
            fontFamily: "Inter",
            fontSize: 16,
            fontWeight: "normal",
            fontStyle: "normal",
            lineHeight: 12,
            letterSpacing: -0.2,
            textAlign: "left",
            color: "#54565b",
            textDecorationLine: "underline",
          },
          carImageStyle: {
            resizeMode: "center",
            height: '100%',
            width: '50%',
            alignSelf: "flex-end",
            position: "absolute",
            bottom: -10,
            right: 0,
            aspectRatio: 1.3,
        },
        whatsupTextLink:{
          top:0,
          flexDirection:'row',
          alignItems:'center',
          left:40,
          width:'fit-content',
      },
      whatsupText:{
          fontFamily: FONTS.Inter,
          fontSize: 12,
          color: COLORS.warmGrey1,
          paddingLeft:10
      }
    },

    {
        [DEVICE_SIZES.LG]: {
            mobileFirstForwardViewStyle: {
                display: "none",
              },
              keepMvngTextStyle: {
                fontFamily: "Inter",
                fontSize: 62,
                fontWeight: "100",
                fontStyle: "normal",
                lineHeight: 66,
                letterSpacing: 0,
                textAlign: "left",
                color: "#9c1d25",
                paddingTop: "10%",
              },
              forwardTextStyle: {
                fontFamily: "Inter",
                fontSize: 66,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 66,
                letterSpacing: 0,
                textAlign: "left",
                color: "#9c1d25",
                paddingTop: 5,
              },
              oneFastagTextStyle: {
                fontFamily: "Inter",
                fontSize: 23,
                fontStyle: "normal",
                lineHeight: 32,
                letterSpacing: 1,
                textAlign: "left",
                color: "#54565b",
                paddingTop: "10%",
              },
              viewStyle1: {
                paddingTop: "10%",
                flexWrap: "wrap",
              },
              activateUserTextStyle: {
                fontFamily: "Inter",
                fontSize: 18,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
              },
              checkTagBalanceTextStyle: {
                fontFamily: "Inter",
                fontSize: 18,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
              },
            

        },
        [DEVICE_SIZES.MD]: {
            mobileFirstForwardViewStyle: {
                display: "none",
              },
              keepMvngTextStyle: {
                fontFamily: "Inter",
                fontSize: 23,
                fontWeight: "200",
                fontStyle: "normal",
                lineHeight: 44,
                letterSpacing: 0,
                textAlign: "left",
                color: "#54565b",
                paddingTop: "10%",
              },
              forwardTextStyle: {
                fontFamily: "Inter",
                fontSize: 44,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 44,
                letterSpacing: 0,
                textAlign: "left",
                color: "#9c1d25",
                paddingTop: 5,
              },
              oneFastagTextStyle: {
                fontFamily: "Inter",
                fontSize: 16,
                fontStyle: "normal",
                lineHeight: 22,
                letterSpacing: 1,
                textAlign: "left",
                color: "#54565b",
                paddingTop: "10%",
              },
              viewStyle1: {
                paddingTop: "10%",
                flexWrap: "wrap",
              },
              activateUserTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
              },
              checkTagBalanceTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
              },

        },
        [DEVICE_SIZES.SM]: {
            mobileFirstForwardViewStyle: {
                display: "none",
              },
            keepMvngTextStyle: {
            fontFamily: "Inter",
            fontSize: 42,
            fontWeight: "200",
            fontStyle: "normal",
            lineHeight: 44,
            letterSpacing: 0,
            textAlign: "left",
            color: "#9c1d25",
            paddingTop: "10%",
            },
            forwardTextStyle: {
                fontFamily: "Inter",
                fontSize: 44,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 44,
                letterSpacing: 0,
                textAlign: "left",
                color: "#9c1d25",
                paddingTop: 5,
              },
              oneFastagTextStyle: {
                fontFamily: "Inter",
                fontSize: 16,
                fontStyle: "normal",
                lineHeight: 22,
                letterSpacing: 1,
                textAlign: "left",
                color: "#54565b",
                paddingTop: "10%",
              },
              viewStyle1: {
                paddingTop: "10%",
                flexWrap: "wrap",
              },
              activateUserTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
              },
              checkTagBalanceTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
              },

        },
        [DEVICE_SIZES.XS]: {
            mobileFirstForwardViewStyle: {
                display: "flex",
              },
              keepMvngTextStyle: {
                fontFamily: "Inter",
                fontSize: 33,
                fontWeight: "200",
                lineHeight: 20,
                textAlign: "left",
                color: "#9c1d25",
                paddingTop: "10%",
              },
              forwardTextStyle: {
                fontFamily: "Inter",
                fontSize: 34,
                lineHeight: 36,
                letterSpacing: 0,
                textAlign: "left",
                color: "#9c1d25",
                paddingTop: 5,
              },
              oneFastagTextStyle: {
                fontFamily: "Inter",
                fontSize: 14,
                lineHeight: 21,
                letterSpacing: 0.4,
                textAlign: "left",
                color: "#54565b",
                paddingTop: 0,
                paddingLeft: "12%",
              },
              viewStyle1: {
                paddingTop: 10,
                flexWrap: "wrap",
              },
              activateUserTextStyle: {
                fontFamily: "Inter",
                fontSize: 14,
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
                paddingLeft: "2%",
              },
              heckTagBalanceTextStyle: {
                fontFamily: "Inter",
                fontSize: 14,
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
                paddingTop: 0,
                paddingLeft: "2%",
              },
              checkTagBalanceTextStyle: {
                fontFamily: "Inter",
                fontSize: 14,
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
                paddingTop: 0,
                paddingLeft: "2%",
              },
              carImageStyle:{
                height:'100%'
              }
        
        },
    }
);

export default useStyles;